module.exports = __webpack_public_path__ + "static/assets/1c9099a7cf1c142492de1603b20b0d44.mp3";